import { Route, Routes } from "react-router-dom";
import PageNotFound from "../pageNoFound";
import ReportsList from "./ReportsList";
import ErrorBoundry from "../../Services/ErrorBoundry";
import AllowedAccess from "../../Layout/AllowedAccess";
import { useSelector } from "react-redux";
import MembersAttendanceReport from "./MembersAttendanceReport";

const ReportsRoutes = () => {
	const { userData } = useSelector((state) => state.user);
	return (
		<Routes>
			<Route
				index
				element={
					<AllowedAccess
						role={userData.role_slug}
						allowedRoles={["super_admin","org_admin","captain","div_admin"]}
						renderNoAccess={() => <ErrorBoundry />}
						children={<ReportsList />}
					/>
				}
			/>
			<Route path="members-attandance-report" element={
				<AllowedAccess
					role={userData.role_slug}
					allowedRoles={["super_admin","org_admin","captain","div_admin"]}
					renderNoAccess={() => <ErrorBoundry />}
					children={<MembersAttendanceReport />}
				/>
			} />
			<Route path="*" element={<PageNotFound />} />
		</Routes>
	);
}

export default ReportsRoutes;